//@ts-check
/**
 * Which thing the edit sheet is open on, if any.
 *
 * Like the capture sheet, the edit sheet lives in the signed-in layout and is opened from cards on
 * any screen. It holds only the id: the sheet reads the thing itself from the things store, so it
 * never edits a stale copy.
 */

/** @type {{ thingId: string }} */
export const editing = $state({ thingId: "" });

/** @param {string} thingId */
export function openEdit(thingId) {
  editing.thingId = thingId;
}

export function closeEdit() {
  editing.thingId = "";
}
